import { WixStyleReactMaskingProviderProps } from './WixStyleReactMaskingProvider.types';

// This object should contain a mock value for each required prop of this component
export const requiredProps: WixStyleReactMaskingProviderProps = {};

// This array should contain an object only for tests you wish to run on all compliance tests
const sharedTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
    } as WixStyleReactMaskingProviderProps,
  },
];

export const testkitTests = [...sharedTests];

export const ssrTests = [...sharedTests];

export const a11yTests = [...sharedTests];
